<template>

<button class="btn btn-success btn-sm" @click="showModal = true">
        <span>{{ props.buttonName }}</span>
        
    </button>

<div class="modal" v-show="showModal">

<!-- Modal content -->
<div class="modal-content">
    <span class="close" @click="showModal = false">&times;</span>
    <slot :closeModal="closeModal"></slot>
    
</div>

</div>

    
</template>

<script setup>

import { ref, defineProps } from 'vue';

const showModal = ref(false);

const props = defineProps(['buttonName']);

function closeModal(bol){
    showModal.value = bol;
}



</script>

<style scoped>
 .add {
    height: 15px;
  }
.modal {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  overflow: auto;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background-color: #fefefe;
  padding: 20px;
  border: 1px solid #888;
  width: 100%;
  max-width: 1000px; /* Adjust the max-width as needed */
  border-radius: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

</style>